export default "__VITE_ASSET__xu20NWZ5__"